import { Link } from "react-router";
import { BriefcaseIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { Card } from "@/components/ui/card";
import { ServiceItem } from "./service-item";
import { useServices } from "../api/get-services";
import { useServiceTypes } from "@/api/get-service-types";

export const ServiceList = () => {
    // Get Services
    const { data: services, isLoading } = useServices();

    const { data: serviceTypes = [] } = useServiceTypes();

    const serviceTypeMap = Object.fromEntries(
        serviceTypes.map((t) => [t.typeGuid, t.title]),
    );

    if (isLoading) {
        return (
            <div className="grid h-75 place-items-center">
                <Spinner size="lg" />
            </div>
        );
    }

    if (!services?.length) {
        return (
            <div className="col-span-full grid grid-cols-subgrid gap-y-4">
                <Card size="lg" className="grid grid-cols-12 items-start">
                    <div className="col-span-full grid grid-cols-subgrid md:col-span-3">
                        <div className="col-span-full">
                            <h2 className="mb-3 text-xl font-semibold">
                                Current services
                            </h2>
                        </div>
                    </div>
                    <div className="col-span-full mx-auto text-center">
                        <BriefcaseIcon className="mx-auto size-15" />
                        <h3 className="mt-2 mb-3 text-xl/8 font-semibold">
                            No services configured
                        </h3>
                        <p className="mb-5">
                            Get started by adding your first service.
                        </p>
                        <Button variant="primary" className="mx-auto" asChild>
                            <Link to="/clinician/services/new">
                                <PlusIcon className="stroke-2" />
                                Add Service
                            </Link>
                        </Button>
                    </div>
                </Card>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-12 items-start gap-y-4">
            {services.map((service) => {
                return (
                    <ServiceItem
                        key={service.serviceGuid}
                        service={service}
                        serviceTypeMap={serviceTypeMap}
                    />
                );
            })}
        </div>
    );
};
